document.addEventListener("DOMContentLoaded", function () {
  // Find all tab sections on the page
  const tabSections = document.querySelectorAll(".collection-tabbing-section");
  
  tabSections.forEach(function(section) {
    const tabs = section.querySelectorAll(".nav-link");
    const contents = section.querySelectorAll(".tab-content");

    function deactivateAllTabs() {
      tabs.forEach((tab) => {
        tab.classList.remove("active");
        tab.setAttribute("aria-selected", "false");
      });
      contents.forEach((content) => {
        content.classList.remove("active");
        content.style.display = "none";
      });
    }

    function activateTab(tab) {
      const tabId = tab.getAttribute("data-tab");
      const content = section.querySelector("#" + tabId);

      if (content) {
        tab.classList.add("active");
        tab.setAttribute("aria-selected", "true");
        content.classList.add("active");
        content.style.display = "block";
      }
    }

    // Add click event listeners to tabs
    tabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        deactivateAllTabs();
        activateTab(this);
      });
    });

    // Initialize first tab as active if tabs exist
    if (tabs.length > 0) {
      deactivateAllTabs();
      activateTab(tabs[0]);
    }
  });
});
